export default __webpack_public_path__ + "menu-categories-smop-icon.88dc545a04a348a02315121831139bda.svg";